import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import './App.scss';
import './styles/utility.scss';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from './pages/login.page';
import ForgotPassword from './pages/forgot-password.page';
import ResetPassword from './pages/reset-password.page';
import MainLayout from './pages/main-layout.page';
import Dashboard from './pages/dashboard.page';
import Detail from './pages/detail.page';
import CreateInfoGraphic from './pages/create-infographic.page';
import { ProviderContextProvider } from './context/provider.context';
import { PaginationFilterProvider } from "./context/pagination.context";
import UserManagement from './pages/user-management.page';
import AdjustInfographic from './pages/adjust-infographic.page';
import { useAuth } from './utility/use-auth';
import NotFound from './pages/not-found.page';
import AppTheme from "./AppTheme";
import TranscriptInfographic from "./pages/transcript-infographic.page";

function App() {
  const originalConsoleWarn = console.warn;
  console.warn = (message, ...args) => {
    if (!message.includes("DOMNodeInserted")) {
      originalConsoleWarn(message, ...args);
    }
  };

  return (
    <AppTheme>
      <div className="App">
        <BrowserRouter>
          <ProviderContextProvider>
            <PaginationFilterProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/" element={<MainLayout />}>
                  {/* Define routes for the right-side content */}
                  <Route index element={<Dashboard />} />
                  <Route path="dashboard" element={<Dashboard />} /> {/* Dynamic route */}
                  <Route path="detail/:id" element={<Detail />} /> {/* Dynamic route */}
                  <Route path="users-management" element={<UserManagement />} />

                  <Route path="infographic/create/:id" element={<CreateInfoGraphic />} /> {/* Dynamic route */}
                  <Route path="infographic/edit/:mediaId/:infoId" element={<AdjustInfographic />} /> {/* Dynamic route */}
                  <Route path="infographic/transcript/:mediaId/:infoId" element={<TranscriptInfographic />} />
                </Route>
                {/* Catch-all route for 404 */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </PaginationFilterProvider>
          </ProviderContextProvider>
        </BrowserRouter>
      </div>
    </AppTheme>
  );
}

export default App;
